import React from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";

// material-ui imports
import { makeStyles } from "@material-ui/core/styles";
import { TableCell, TableRow } from "@material-ui/core";

// internal UI components
import { areAttachmentsEnabled } from "../../../globals/workOrderStatus";

const useStyles = makeStyles((theme) => ({
    fileName: {
        color: "var(--blue-bell)",
        "&:hover": {
            cursor: "pointer",
        },
    },
}));

const AttachmentRow = (props) => {
    const { file, workOrderStatus, handleAttachmentSelect } = props;
    const classes = useStyles();

    const formatDate = (date) => {
        if (!date) return "";

        return moment(date).format("MMM DD, YYYY HH:mm");
    };

    return (
        <TableRow>
            <TableCell align="left">
                <span className={classes.fileName} onClick={handleAttachmentSelect}>
                    <FormattedMessage
                        id="admin.work-order-details.attachments-table.name-with-size"
                        defaultMessage="{name} ({size} bytes)"
                        description="File name field in table with size in bytes"
                        values={{
                            name: file.fileNameNoExt,
                            size: file.size,
                        }}
                    />
                </span>
            </TableCell>
            <TableCell align="left">{file.fileType}</TableCell>
            <TableCell align="left">{file.uploadedBy}</TableCell>
            <TableCell align="left">{formatDate(file.createdDateTime)}</TableCell>
            <TableCell align="left">{file.fileDescription ? file.fileDescription : ""}</TableCell>
        </TableRow>
    );
};

export default AttachmentRow;
